const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 15",
    d: "M19783.035-8131a.8.8 0 0 1-.8-.8v-5.6a3.2 3.2 0 0 1-3.2-3.2 3.2 3.2 0 0 1 3.2-3.2h3.844l7.857-3.143a.8.8 0 0 1 .746.081.8.8 0 0 1 .352.662v11.2a.8.8 0 0 1-.352.665.8.8 0 0 1-.746.081l-6.9-2.761v5.215a.8.8 0 0 1-.8.8zm.8-1.6h1.6v-4.8h-1.6zm3.2-9.859v3.717l6.4 2.56v-8.837zm-6.4 1.858a1.6 1.6 0 0 0 1.6 1.6h3.2v-3.2h-3.2a1.6 1.6 0 0 0-1.6 1.601zm19.916 5.493a.8.8 0 0 1-.293-1.093 8.8 8.8 0 0 0 0-8.8.8.8 0 0 1 .293-1.093.8.8 0 0 1 1.092.292 10.4 10.4 0 0 1 0 10.4.8.8 0 0 1-.486.373.8.8 0 0 1-.207.027.792.792 0 0 1-.399-.098zm-2.773-1.6a.8.8 0 0 1-.293-1.093 5.6 5.6 0 0 0 0-5.6.8.8 0 0 1 .293-1.093.8.8 0 0 1 1.092.293 7.2 7.2 0 0 1 0 7.2.8.8 0 0 1-.484.374.814.814 0 0 1-.207.027.794.794 0 0 1-.402-.1z",
    transform: "translate(-19779.034 8150.998)",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1179",
    transform: "translate(.001)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/station.d5c78ec9295ccd44c6a68eb28c62f638.svg";
export { ForwardRef as ReactComponent };